import { SVGProps } from 'react';
import { Theme } from '~/types';

interface LogoProps extends SVGProps<SVGSVGElement> {
    theme?: Theme;
    hideText?: boolean;
}

export const Logo = ({ ...props }: LogoProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={31}
        height={31}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="#3A8DDE"
                d="M30.752 15.442c0-8.491-6.884-15.377-15.375-15.377C6.885.065 0 6.951 0 15.442 0 23.934 6.884 30.82 15.377 30.82s15.377-6.884 15.377-15.377"
            />
            <g opacity={0.8}>
                <mask
                    id="b"
                    width={7}
                    height={5}
                    x={16}
                    y={22}
                    maskUnits="userSpaceOnUse"
                    style={{
                        maskType: 'luminance',
                    }}
                >
                    <path
                        fill="#fff"
                        d="M22.719 22.305h-5.834v3.775h5.834v-3.775Z"
                    />
                </mask>
                <g mask="url(#b)">
                    <mask
                        id="c"
                        width={7}
                        height={5}
                        x={16}
                        y={22}
                        maskUnits="userSpaceOnUse"
                        style={{
                            maskType: 'luminance',
                        }}
                    >
                        <path
                            fill="#fff"
                            d="M22.664 22.324h-5.7v3.677h5.7v-3.677Z"
                        />
                    </mask>
                    <g mask="url(#c)">
                        <path
                            fill="#E9F2FB"
                            d="M16.964 24.134a5.857 5.857 0 0 0 4.293 1.867c.486 0 .956-.06 1.405-.17a9.56 9.56 0 0 0-2.222-3.507c-1.366.19-2.58.85-3.478 1.81"
                        />
                    </g>
                </g>
            </g>
            <g opacity={0.4}>
                <mask
                    id="d"
                    width={28}
                    height={29}
                    x={0}
                    y={0}
                    maskUnits="userSpaceOnUse"
                    style={{
                        maskType: 'luminance',
                    }}
                >
                    <path fill="#fff" d="M27.18 0H.757v28.825H27.18V0Z" />
                </mask>
                <g mask="url(#d)">
                    <mask
                        id="e"
                        width={28}
                        height={29}
                        x={0}
                        y={0}
                        maskUnits="userSpaceOnUse"
                        style={{
                            maskType: 'luminance',
                        }}
                    >
                        <path
                            fill="#fff"
                            d="M27.128.058H.781v28.625h26.348V.058Z"
                        />
                    </mask>
                    <g fill="#E9F2FB" mask="url(#e)">
                        <path d="M27.113 19.73a8.074 8.074 0 0 1-4.171-5.226 5.871 5.871 0 0 0-7.537 5.16 9.545 9.545 0 0 1 5.035 2.659 5.852 5.852 0 0 1 5.11 1.81 5.846 5.846 0 0 0 1.563-4.405M7.743 18.786a3.081 3.081 0 0 1-3.018 2.466c-1.489 0-2.633-.98-2.978-2.306-.4.379-.73.83-.968 1.333a15.393 15.393 0 0 0 3.713 6.028 9.595 9.595 0 0 1 4.562-5.627 4.466 4.466 0 0 0-1.31-1.894ZM14.308 7.675a8.744 8.744 0 0 1-6.865 4.5 4.339 4.339 0 0 0 8.545-1.075 4.33 4.33 0 0 0-1.68-3.425ZM20.984 9.343c0 1.135.733 2.098 1.75 2.446a8.04 8.04 0 0 1 2.09-4.71 2.587 2.587 0 0 0-3.84 2.263ZM22.662 25.831c.323.896.515 1.853.555 2.852a15.499 15.499 0 0 0 3.462-2.799 5.891 5.891 0 0 0-1.129-1.75 5.86 5.86 0 0 1-2.888 1.697ZM14.96 6.163a5.188 5.188 0 0 0 7.062-4.603A15.328 15.328 0 0 0 14.701.076a8.752 8.752 0 0 1 .257 6.09" />
                    </g>
                </g>
            </g>
            <g opacity={0.2}>
                <mask
                    id="f"
                    width={31}
                    height={31}
                    x={0}
                    y={0}
                    maskUnits="userSpaceOnUse"
                    style={{
                        maskType: 'luminance',
                    }}
                >
                    <path
                        fill="#fff"
                        d="M30.783.343H.928v30.541h29.855V.344Z"
                    />
                </mask>
                <g mask="url(#f)">
                    <mask
                        id="g"
                        width={31}
                        height={31}
                        x={0}
                        y={0}
                        maskUnits="userSpaceOnUse"
                        style={{
                            maskType: 'luminance',
                        }}
                    >
                        <path
                            fill="#fff"
                            d="M30.77.503H.951v30.325H30.77V.503Z"
                        />
                    </mask>
                    <g fill="#E9F2FB" mask="url(#g)">
                        <path d="M7.443 12.175a4.36 4.36 0 0 1-.139-1.075 4.342 4.342 0 0 1 4.343-4.343 4.33 4.33 0 0 1 2.663.916 8.8 8.8 0 0 0 .652-1.51A5.191 5.191 0 0 1 11.716.501 15.417 15.417 0 0 0 .95 10.108a8.704 8.704 0 0 0 6.492 2.069M15.384 20.13c0-.156.008-.31.02-.465a9.534 9.534 0 0 0-6.35 1.014 4.482 4.482 0 0 1-4.175 5.995 15.33 15.33 0 0 0 11.148 4.133 5.847 5.847 0 0 1-.643-2.671c0-1.548.6-2.955 1.578-4.005a5.854 5.854 0 0 1-1.578-4.005M27.024 5.388a8.125 8.125 0 0 0-2.2 1.691 2.587 2.587 0 0 1-2.09 4.71 7.998 7.998 0 0 0 .208 2.716 5.873 5.873 0 0 1 4.171 5.227c.851.434 1.788.72 2.781.828.565-1.6.875-3.321.875-5.116 0-3.845-1.413-7.357-3.745-10.055M7.805 18.172a3.08 3.08 0 0 0-6.16 0c0 .268.038.527.102.774a4.471 4.471 0 0 1 3.086-1.234 4.46 4.46 0 0 1 2.91 1.074c.04-.199.062-.403.062-.614Z" />
                    </g>
                </g>
            </g>
            <g opacity={0.6}>
                <mask
                    id="h"
                    width={27}
                    height={31}
                    x={1}
                    y={0}
                    maskUnits="userSpaceOnUse"
                    style={{
                        maskType: 'luminance',
                    }}
                >
                    <path fill="#fff" d="M27.18 0H1.615v30.884H27.18V0Z" />
                </mask>
                <mask
                    id="i"
                    width={27}
                    height={31}
                    x={1}
                    y={0}
                    maskUnits="userSpaceOnUse"
                    style={{
                        maskType: 'luminance',
                    }}
                >
                    <path
                        fill="#fff"
                        d="M27.115.076H1.748V30.81h25.367V.076Z"
                    />
                </mask>
                <g fill="#E9F2FB" mask="url(#i)">
                    <path d="M15.405 19.666a5.857 5.857 0 0 0 1.558 4.47 5.86 5.86 0 0 1 3.477-1.81 9.551 9.551 0 0 0-5.036-2.66ZM4.492 26.307c.125.127.257.248.388.37a4.481 4.481 0 0 0 4.174-5.995 9.595 9.595 0 0 0-4.562 5.626M7.303 11.1c0 .372.051.73.138 1.075a8.747 8.747 0 0 0 6.865-4.5 4.316 4.316 0 0 0-2.662-.916A4.342 4.342 0 0 0 7.3 11.1M22.942 14.505a8.093 8.093 0 0 0 4.171 5.227 5.873 5.873 0 0 0-4.171-5.227ZM26.16 9.343c0-.975-.54-1.823-1.336-2.264a8.036 8.036 0 0 0-2.09 4.71 2.587 2.587 0 0 0 3.425-2.447ZM21.257 22.266c-.276 0-.549.02-.817.058a9.561 9.561 0 0 1 2.222 3.507 5.862 5.862 0 0 0 2.888-1.697 5.852 5.852 0 0 0-4.293-1.868Z" />
                    <path d="M16.964 24.134a5.846 5.846 0 0 0-1.578 4.005c0 .963.233 1.87.643 2.672a15.303 15.303 0 0 0 7.19-2.128 9.516 9.516 0 0 0-.555-2.852c-.451.11-.921.17-1.405.17a5.852 5.852 0 0 1-4.293-1.868M14.701.076c-1.026.044-2.025.19-2.989.427a5.193 5.193 0 0 0 3.246 5.662 8.74 8.74 0 0 0 .426-2.696c0-1.204-.244-2.35-.683-3.393ZM7.743 18.786a4.465 4.465 0 0 0-2.91-1.074c-1.195 0-2.282.47-3.086 1.234a3.077 3.077 0 0 0 2.978 2.306c1.435 0 2.734-1.059 3.018-2.466Z" />
                </g>
            </g>
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h31v31H0z" />
            </clipPath>
        </defs>
    </svg>
);

/**
 * Os logos foram alterados para viewbox e height 100% para melhor responsividade e poderem usar a mesma imagem em diferentes tamanhos
 * No componente pode-se definir tamanhos na ClassName Exemplo: h-8 w-auto
 * Antes o tamanho era fixo 100x32
 * @param param0
 * @returns
 */
export const LogoWithText = ({ theme, hideText, ...props }: LogoProps) => {
    if (theme === 'dark') {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 32"
                height="100%"
                preserveAspectRatio="xMinYMid meet"
                fill="none"
                {...props}
            >
                <g clipPath="url(#a)">
                    <path
                        fill="#3A8DDE"
                        d="M30.752 16c0-8.491-6.884-15.377-15.375-15.377C6.885.623 0 7.509 0 16s6.884 15.377 15.377 15.377S30.754 24.493 30.754 16"
                    />
                    <g opacity={0.8}>
                        <mask
                            id="b"
                            width={7}
                            height={5}
                            x={16}
                            y={22}
                            maskUnits="userSpaceOnUse"
                            style={{
                                maskType: 'luminance',
                            }}
                        >
                            <path
                                fill="#fff"
                                d="M22.719 22.863h-5.834v3.775h5.834v-3.775Z"
                            />
                        </mask>
                        <g mask="url(#b)">
                            <mask
                                id="c"
                                width={7}
                                height={5}
                                x={16}
                                y={22}
                                maskUnits="userSpaceOnUse"
                                style={{
                                    maskType: 'luminance',
                                }}
                            >
                                <path
                                    fill="#fff"
                                    d="M22.664 22.882h-5.7v3.677h5.7v-3.677Z"
                                />
                            </mask>
                            <g mask="url(#c)">
                                <path
                                    fill="#fff"
                                    d="M16.964 24.692a5.857 5.857 0 0 0 4.293 1.867c.486 0 .956-.06 1.405-.17a9.56 9.56 0 0 0-2.222-3.507c-1.366.19-2.58.85-3.478 1.81"
                                />
                            </g>
                        </g>
                    </g>
                    <g opacity={0.4}>
                        <mask
                            id="d"
                            width={28}
                            height={30}
                            x={0}
                            y={0}
                            maskUnits="userSpaceOnUse"
                            style={{
                                maskType: 'luminance',
                            }}
                        >
                            <path
                                fill="#fff"
                                d="M27.18.558H.757v28.825H27.18V.558Z"
                            />
                        </mask>
                        <g mask="url(#d)">
                            <mask
                                id="e"
                                width={28}
                                height={30}
                                x={0}
                                y={0}
                                maskUnits="userSpaceOnUse"
                                style={{
                                    maskType: 'luminance',
                                }}
                            >
                                <path
                                    fill="#fff"
                                    d="M27.128.616H.781v28.625h26.348V.616Z"
                                />
                            </mask>
                            <g fill="#fff" mask="url(#e)">
                                <path d="M27.113 20.288a8.074 8.074 0 0 1-4.171-5.226 5.871 5.871 0 0 0-7.538 5.16 9.544 9.544 0 0 1 5.036 2.658 5.852 5.852 0 0 1 5.11 1.81 5.846 5.846 0 0 0 1.563-4.404M7.743 19.344a3.081 3.081 0 0 1-3.018 2.466c-1.49 0-2.634-.98-2.978-2.306-.4.379-.73.83-.968 1.333a15.393 15.393 0 0 0 3.713 6.028 9.595 9.595 0 0 1 4.562-5.627 4.466 4.466 0 0 0-1.31-1.894ZM14.308 8.233a8.745 8.745 0 0 1-6.865 4.5 4.339 4.339 0 0 0 8.545-1.076 4.33 4.33 0 0 0-1.68-3.424ZM20.984 9.9c0 1.136.732 2.099 1.75 2.447a8.04 8.04 0 0 1 2.09-4.71 2.587 2.587 0 0 0-3.84 2.263ZM22.662 26.39c.323.895.515 1.852.554 2.85a15.497 15.497 0 0 0 3.463-2.798 5.892 5.892 0 0 0-1.13-1.75 5.862 5.862 0 0 1-2.887 1.697ZM14.96 6.721a5.188 5.188 0 0 0 7.062-4.603A15.328 15.328 0 0 0 14.701.633a8.752 8.752 0 0 1 .257 6.09" />
                            </g>
                        </g>
                    </g>
                    <g opacity={0.2}>
                        <mask
                            id="f"
                            width={31}
                            height={32}
                            x={0}
                            y={0}
                            maskUnits="userSpaceOnUse"
                            style={{
                                maskType: 'luminance',
                            }}
                        >
                            <path
                                fill="#fff"
                                d="M30.783.901H.928v30.541h29.855V.902Z"
                            />
                        </mask>
                        <g mask="url(#f)">
                            <mask
                                id="g"
                                width={31}
                                height={31}
                                x={0}
                                y={1}
                                maskUnits="userSpaceOnUse"
                                style={{
                                    maskType: 'luminance',
                                }}
                            >
                                <path
                                    fill="#fff"
                                    d="M30.77 1.06H.951v30.326H30.77V1.06Z"
                                />
                            </mask>
                            <g fill="#fff" mask="url(#g)">
                                <path d="M7.443 12.733a4.36 4.36 0 0 1-.14-1.075 4.342 4.342 0 0 1 4.343-4.343 4.33 4.33 0 0 1 2.663.916c.263-.479.48-.983.652-1.51a5.191 5.191 0 0 1-3.246-5.662A15.417 15.417 0 0 0 .95 10.666a8.704 8.704 0 0 0 6.493 2.07M15.383 20.688c0-.156.01-.31.021-.465a9.534 9.534 0 0 0-6.35 1.014 4.482 4.482 0 0 1-4.175 5.995 15.33 15.33 0 0 0 11.148 4.133 5.847 5.847 0 0 1-.644-2.671c0-1.548.601-2.955 1.579-4.005a5.854 5.854 0 0 1-1.579-4.005M27.023 5.946a8.125 8.125 0 0 0-2.2 1.691 2.587 2.587 0 0 1-2.09 4.71 7.998 7.998 0 0 0 .208 2.716 5.873 5.873 0 0 1 4.172 5.227c.85.434 1.787.72 2.78.828.565-1.6.876-3.321.876-5.116 0-3.845-1.414-7.357-3.746-10.055M7.805 18.73a3.08 3.08 0 0 0-6.16 0c0 .268.038.527.101.774a4.471 4.471 0 0 1 3.087-1.234 4.46 4.46 0 0 1 2.91 1.074c.04-.199.062-.403.062-.614Z" />
                            </g>
                        </g>
                    </g>
                    <g opacity={0.6}>
                        <mask
                            id="h"
                            width={27}
                            height={32}
                            x={1}
                            y={0}
                            maskUnits="userSpaceOnUse"
                            style={{
                                maskType: 'luminance',
                            }}
                        >
                            <path
                                fill="#fff"
                                d="M27.18.558H1.615v30.884H27.18V.558Z"
                            />
                        </mask>
                        <mask
                            id="i"
                            width={27}
                            height={32}
                            x={1}
                            y={0}
                            maskUnits="userSpaceOnUse"
                            style={{
                                maskType: 'luminance',
                            }}
                        >
                            <path
                                fill="#fff"
                                d="M27.115.633H1.749v30.735h25.366V.633Z"
                            />
                        </mask>
                        <g fill="#fff" mask="url(#i)">
                            <path d="M15.404 20.224a5.857 5.857 0 0 0 1.558 4.47 5.86 5.86 0 0 1 3.478-1.81 9.55 9.55 0 0 0-5.036-2.66ZM4.492 26.864c.125.127.258.25.388.371a4.481 4.481 0 0 0 4.174-5.995 9.595 9.595 0 0 0-4.562 5.626M7.303 11.657c0 .373.051.731.138 1.076a8.747 8.747 0 0 0 6.865-4.5 4.316 4.316 0 0 0-2.662-.917A4.342 4.342 0 0 0 7.3 11.66M22.942 15.063a8.093 8.093 0 0 0 4.171 5.226 5.873 5.873 0 0 0-4.171-5.226ZM26.16 9.9c0-.974-.54-1.822-1.336-2.263a8.036 8.036 0 0 0-2.09 4.71A2.587 2.587 0 0 0 26.16 9.9ZM21.257 22.824c-.276 0-.549.02-.817.058a9.56 9.56 0 0 1 2.222 3.507 5.862 5.862 0 0 0 2.888-1.697 5.852 5.852 0 0 0-4.293-1.868Z" />
                            <path d="M16.964 24.692a5.847 5.847 0 0 0-1.578 4.005c0 .962.233 1.87.643 2.671a15.303 15.303 0 0 0 7.19-2.127 9.518 9.518 0 0 0-.555-2.852c-.451.11-.921.17-1.405.17a5.852 5.852 0 0 1-4.293-1.869M14.701.633c-1.026.045-2.024.19-2.989.428a5.193 5.193 0 0 0 3.246 5.662c.275-.85.426-1.754.426-2.696 0-1.204-.244-2.35-.683-3.394ZM7.744 19.344a4.464 4.464 0 0 0-2.91-1.074 4.47 4.47 0 0 0-3.087 1.234 3.077 3.077 0 0 0 2.979 2.306c1.434 0 2.733-1.059 3.018-2.466Z" />
                        </g>
                    </g>
                    <path
                        fill="#fff"
                        d="M49.732 8.384h-.063c-.515 0-.903.406-.903.945v10.756L40.385 8.927c-.112-.149-.407-.543-.939-.543h-.106c-.563 0-.987.434-.987 1.008v13.334c0 .539.388.945.902.945h.064c.527 0 .923-.406.923-.945V11.862l8.47 11.262c.123.196.37.547.914.547h.063c.539 0 .946-.415.946-.966V9.33c0-.621-.455-.945-.903-.945ZM60.372 9.017c-.168-.417-.53-.656-.995-.656-.465 0-.805.237-.973.652L52.86 22.494a.771.771 0 0 0-.043.448c.081.398.431.698.851.733.024.002.047.003.072.003.337 0 .766-.183.958-.7l1.487-3.655h6.373l1.498 3.652.015.034c.21.45.633.707 1.08.652.406-.05.73-.34.806-.722a.793.793 0 0 0-.043-.446L60.37 9.015l.002.002Zm-3.445 8.46 2.45-5.931 2.42 5.931h-4.87ZM77.467 8.396c-.395-.083-.906.09-1.162.677l-4.746 11.46-4.754-11.434c-.222-.592-.735-.782-1.141-.707-.441.08-.762.448-.762.873 0 .103.02.205.06.299l5.607 13.477c.168.414.522.652.971.652.484 0 .863-.269.99-.694l5.61-13.433a.779.779 0 0 0 .06-.299.906.906 0 0 0-.733-.87M81.346 8.384h-.064c-.518 0-.923.415-.923.945v13.397c0 .53.407.945.924.945h.063c.515 0 .903-.406.903-.945V9.329c0-.539-.388-.945-.903-.945ZM97.17 22.494 91.628 9.018c-.166-.416-.53-.657-.995-.657-.465 0-.805.239-.973.652l-5.544 13.481a.779.779 0 0 0-.043.446.94.94 0 0 0 .85.736c.027.002.053.004.079.004.42 0 .79-.275.95-.7l1.898-4.6h5.585l1.877 4.597.015.035c.256.546.723.694 1.08.652a.923.923 0 0 0 .808-.72.768.768 0 0 0-.043-.448m-8.58-5.964 2.04-4.986 2.041 4.986h-4.08ZM97.047 8.728h-.871v2.22h-.304v-2.22h-.873v-.284h2.048v.284ZM100 10.949h-.288V9.374l.034-.661h-.005l-.822 2.236h-.259l-.823-2.236h-.004l.034.66v1.576h-.288V8.444h.467l.55 1.522.19.626h.008l.192-.623.547-1.525H100v2.505Z"
                    />
                </g>
                <defs>
                    <clipPath id="a">
                        <path fill="#fff" d="M0 .558h100v30.884H0z" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 32"
            height="100%"
            preserveAspectRatio="xMinYMid meet"
            fill="none"
            {...props}
        >
            <g clipPath="url(#a)">
                <path
                    fill="#3A8DDE"
                    d="M30.752 16c0-8.492-6.884-15.377-15.375-15.377C6.885.623 0 7.508 0 16c0 8.491 6.884 15.377 15.377 15.377S30.754 24.493 30.754 16"
                />
                <g opacity={0.8}>
                    <mask
                        id="b"
                        width={7}
                        height={5}
                        x={16}
                        y={22}
                        maskUnits="userSpaceOnUse"
                        style={{
                            maskType: 'luminance',
                        }}
                    >
                        <path
                            fill="#fff"
                            d="M22.719 22.863h-5.834v3.775h5.834v-3.775Z"
                        />
                    </mask>
                    <g mask="url(#b)">
                        <mask
                            id="c"
                            width={7}
                            height={5}
                            x={16}
                            y={22}
                            maskUnits="userSpaceOnUse"
                            style={{
                                maskType: 'luminance',
                            }}
                        >
                            <path
                                fill="#fff"
                                d="M22.664 22.882h-5.7v3.677h5.7v-3.677Z"
                            />
                        </mask>
                        <g mask="url(#c)">
                            <path
                                fill="#E9F2FB"
                                d="M16.964 24.692a5.857 5.857 0 0 0 5.698 1.697 9.56 9.56 0 0 0-2.222-3.507c-1.366.19-2.58.85-3.478 1.81"
                            />
                        </g>
                    </g>
                </g>
                <g opacity={0.4}>
                    <mask
                        id="d"
                        width={28}
                        height={30}
                        x={0}
                        y={0}
                        maskUnits="userSpaceOnUse"
                        style={{
                            maskType: 'luminance',
                        }}
                    >
                        <path
                            fill="#fff"
                            d="M27.18.558H.757v28.825H27.18V.558Z"
                        />
                    </mask>
                    <g mask="url(#d)">
                        <mask
                            id="e"
                            width={28}
                            height={30}
                            x={0}
                            y={0}
                            maskUnits="userSpaceOnUse"
                            style={{
                                maskType: 'luminance',
                            }}
                        >
                            <path
                                fill="#fff"
                                d="M27.128.616H.781v28.625h26.348V.616Z"
                            />
                        </mask>
                        <g fill="#E9F2FB" mask="url(#e)">
                            <path d="M27.113 20.288a8.075 8.075 0 0 1-4.171-5.226 5.871 5.871 0 0 0-7.537 5.16 9.544 9.544 0 0 1 5.035 2.658 5.852 5.852 0 0 1 5.11 1.81 5.846 5.846 0 0 0 1.563-4.404M7.743 19.344a3.081 3.081 0 0 1-3.018 2.466c-1.489 0-2.633-.98-2.978-2.306-.4.379-.73.83-.968 1.333a15.392 15.392 0 0 0 3.713 6.027 9.595 9.595 0 0 1 4.562-5.626 4.466 4.466 0 0 0-1.31-1.894ZM14.308 8.233a8.744 8.744 0 0 1-6.865 4.5 4.339 4.339 0 0 0 8.545-1.076 4.33 4.33 0 0 0-1.68-3.424ZM20.984 9.9c0 1.136.733 2.099 1.75 2.447a8.04 8.04 0 0 1 2.09-4.71 2.587 2.587 0 0 0-3.84 2.263ZM22.662 26.39c.323.895.515 1.852.554 2.85a15.494 15.494 0 0 0 3.463-2.798 5.893 5.893 0 0 0-1.13-1.75 5.862 5.862 0 0 1-2.887 1.697ZM14.96 6.721a5.188 5.188 0 0 0 7.062-4.603A15.328 15.328 0 0 0 14.701.632a8.752 8.752 0 0 1 .257 6.09" />
                        </g>
                    </g>
                </g>
                <g opacity={0.2}>
                    <mask
                        id="f"
                        width={31}
                        height={32}
                        x={0}
                        y={0}
                        maskUnits="userSpaceOnUse"
                        style={{
                            maskType: 'luminance',
                        }}
                    >
                        <path
                            fill="#fff"
                            d="M30.783.901H.928v30.541h29.855V.901Z"
                        />
                    </mask>
                    <g mask="url(#f)">
                        <mask
                            id="g"
                            width={31}
                            height={31}
                            x={0}
                            y={1}
                            maskUnits="userSpaceOnUse"
                            style={{
                                maskType: 'luminance',
                            }}
                        >
                            <path
                                fill="#fff"
                                d="M30.77 1.06H.951v30.325H30.77V1.061Z"
                            />
                        </mask>
                        <g fill="#E9F2FB" mask="url(#g)">
                            <path d="M7.443 12.733a4.36 4.36 0 0 1-.139-1.076 4.342 4.342 0 0 1 4.343-4.342 4.33 4.33 0 0 1 2.663.916 8.8 8.8 0 0 0 .652-1.51 5.191 5.191 0 0 1-3.246-5.662A15.417 15.417 0 0 0 .95 10.666a8.704 8.704 0 0 0 6.492 2.069M15.384 20.688c0-.157.008-.311.02-.465a9.534 9.534 0 0 0-6.35 1.014 4.482 4.482 0 0 1-4.175 5.995 15.329 15.329 0 0 0 11.148 4.133 5.849 5.849 0 0 1-.643-2.671c0-1.548.6-2.955 1.578-4.005a5.854 5.854 0 0 1-1.578-4.005M27.024 5.945a8.126 8.126 0 0 0-2.2 1.692 2.587 2.587 0 0 1-2.09 4.71 7.998 7.998 0 0 0 .208 2.716 5.873 5.873 0 0 1 4.171 5.226c.851.435 1.788.721 2.781.83.565-1.602.875-3.322.875-5.117a15.32 15.32 0 0 0-3.745-10.055M7.805 18.73a3.08 3.08 0 0 0-6.16 0c0 .267.038.527.102.774a4.47 4.47 0 0 1 3.086-1.234 4.46 4.46 0 0 1 2.91 1.074c.04-.199.062-.403.062-.614Z" />
                        </g>
                    </g>
                </g>
                <g opacity={0.6}>
                    <mask
                        id="h"
                        width={27}
                        height={32}
                        x={1}
                        y={0}
                        maskUnits="userSpaceOnUse"
                        style={{
                            maskType: 'luminance',
                        }}
                    >
                        <path
                            fill="#fff"
                            d="M27.18.558H1.615v30.884H27.18V.558Z"
                        />
                    </mask>
                    <mask
                        id="i"
                        width={27}
                        height={32}
                        x={1}
                        y={0}
                        maskUnits="userSpaceOnUse"
                        style={{
                            maskType: 'luminance',
                        }}
                    >
                        <path
                            fill="#fff"
                            d="M27.115.633H1.748v30.735h25.367V.633Z"
                        />
                    </mask>
                    <g fill="#E9F2FB" mask="url(#i)">
                        <path d="M15.404 20.224a5.857 5.857 0 0 0 1.558 4.47 5.859 5.859 0 0 1 3.478-1.81 9.55 9.55 0 0 0-5.036-2.66ZM4.492 26.864c.125.127.257.25.388.371a4.481 4.481 0 0 0 4.174-5.995 9.595 9.595 0 0 0-4.562 5.626M7.302 11.657c0 .373.052.731.14 1.076a8.747 8.747 0 0 0 6.864-4.5 4.316 4.316 0 0 0-2.663-.917 4.342 4.342 0 0 0-4.342 4.343M22.942 15.063a8.093 8.093 0 0 0 4.171 5.226 5.873 5.873 0 0 0-4.171-5.226ZM26.159 9.9c0-.974-.539-1.822-1.335-2.263a8.036 8.036 0 0 0-2.09 4.71A2.587 2.587 0 0 0 26.16 9.9ZM21.257 22.824c-.276 0-.55.02-.817.058a9.562 9.562 0 0 1 2.222 3.507 5.86 5.86 0 0 0 2.888-1.697 5.852 5.852 0 0 0-4.293-1.868Z" />
                        <path d="M16.964 24.692a5.846 5.846 0 0 0-1.578 4.005c0 .962.233 1.87.643 2.671a15.303 15.303 0 0 0 7.19-2.127 9.517 9.517 0 0 0-.555-2.852c-.451.11-.921.17-1.405.17a5.852 5.852 0 0 1-4.293-1.869M14.7.633c-1.025.045-2.024.19-2.988.428a5.193 5.193 0 0 0 3.246 5.662c.275-.85.426-1.754.426-2.696 0-1.204-.244-2.35-.683-3.394ZM7.743 19.344a4.464 4.464 0 0 0-2.91-1.074c-1.196 0-2.282.47-3.086 1.234a3.077 3.077 0 0 0 2.978 2.306c1.435 0 2.734-1.059 3.018-2.466Z" />
                    </g>
                </g>
                <path
                    fill="#323E48"
                    d="M49.732 8.384h-.063c-.515 0-.903.406-.903.945v10.756L40.385 8.927c-.112-.149-.407-.543-.939-.543h-.106c-.563 0-.987.434-.987 1.008v13.334c0 .539.388.945.903.945h.063c.527 0 .923-.406.923-.945V11.862l8.47 11.262c.123.196.37.547.914.547h.063c.54 0 .946-.415.946-.966V9.33c0-.621-.455-.945-.903-.945ZM60.372 9.017c-.168-.417-.53-.656-.995-.656-.465 0-.805.237-.973.652L52.86 22.494a.77.77 0 0 0-.043.448c.081.398.431.698.851.733.024.002.047.003.072.003.337 0 .766-.183.958-.7l1.487-3.655h6.373l1.498 3.652.015.034c.21.45.633.707 1.08.652a.92.92 0 0 0 .806-.722.793.793 0 0 0-.043-.446L60.37 9.015l.002.002Zm-3.445 8.46 2.45-5.931 2.42 5.931h-4.87ZM77.466 8.396c-.394-.083-.905.09-1.161.677l-4.746 11.46L66.805 9.1c-.222-.592-.735-.782-1.142-.707-.44.08-.761.448-.761.873 0 .103.02.205.06.299l5.607 13.478c.168.413.522.652.971.652.484 0 .863-.27.99-.695l5.61-13.433a.78.78 0 0 0 .06-.299.905.905 0 0 0-.734-.87M81.346 8.384h-.064c-.518 0-.923.415-.923.945v13.397c0 .53.407.945.923.945h.064c.515 0 .902-.406.902-.945V9.329c0-.539-.387-.945-.902-.945ZM97.17 22.494 91.628 9.018c-.166-.417-.53-.657-.995-.657-.465 0-.805.239-.973.652l-5.544 13.481a.777.777 0 0 0-.043.446.94.94 0 0 0 .85.736c.027.002.053.004.079.004.42 0 .79-.275.95-.7l1.898-4.6h5.585l1.877 4.596.015.036c.256.546.723.694 1.08.652a.923.923 0 0 0 .808-.72.769.769 0 0 0-.043-.448m-8.58-5.964 2.04-4.986 2.04 4.986h-4.08ZM97.047 8.728h-.871v2.22h-.304v-2.22h-.874v-.284h2.05v.284ZM100 10.949h-.288V9.374l.034-.661h-.005l-.822 2.236h-.259l-.824-2.236h-.003l.034.66v1.576h-.288V8.444h.467l.55 1.522.19.626h.008l.192-.623.547-1.525H100v2.505Z"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 .558h100v30.884H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
